import { api } from "@//api";
import { queryClient } from "@/queryClient";
import { CAMERA_QUERY_KEY } from "@/services/cameras/listCameras";

export const setCameraAnpr = async (cameraId: string, enabled: boolean) => {
  const { body } = await api.put(`/camera/cameras/${cameraId}/anpr`, {
    body: { enabled },
  });
  queryClient.invalidateQueries([CAMERA_QUERY_KEY]);
  return body;
};
